import { useContext } from 'react';
import { Form, Input } from 'antd';
import { I18n } from '@aws-amplify/core';
import { MergeAEPContext } from '../../context';

export function FileName(): JSX.Element {
	const { organizationId, companyId, setFileName, queryParams, setQueryParams } = useContext(MergeAEPContext);

	function handleFileNameChange(fileName: string) {
		setFileName(fileName);
		setQueryParams({
			...queryParams,
			fileName,
		});
	}

	return (
		<Form.Item name="fileName">
			<Input
				placeholder={I18n.get('File Name')}
				disabled={!organizationId || !companyId}
				onChange={(event) => handleFileNameChange(event.target.value)}
			/>
		</Form.Item>
	);
}
